// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__MyPkj","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1tFEY"};